module.exports = __webpack_public_path__ + "img/proList3_08.f6d7e056.jpg";